import React, { useEffect, useState } from 'react'
import './style.scss'
import { FaDotCircle } from "react-icons/fa";
import { customerAxios } from '../../../config/axios';
import { toast } from 'react-hot-toast'
import Spinner from '../../common/spinners/SpinWithMessage'
import InfoBox from '../../common/info-box/InfoBox'
import { IoMdCheckmarkCircle, IoMdRemoveCircle } from "react-icons/io";
import { PiCardholderDuotone } from "react-icons/pi";
import ServiceCard from '../service-card/ServiceCard';
import InstallationCard from '../service-card/InstallationCard';
import { useNavigate } from 'react-router-dom';
import { Rating } from 'react-simple-star-rating'

const CustomerCardDetails = ({ cid }) => {
    const [customer, setCustomer] = useState({})
    const [purifier, setPurifier] = useState({})
    const [cardList, setCardList] = useState([])
    const [cardImageList, setCardImageList] = useState([])
    const [eligibility, setEligibility] = useState({})
    const [loading, setLoading] = useState('fetch')
    const navigate = useNavigate()

    useEffect(() => {
        if (cid) {
            const customerDetails = customerAxios.get(`/profile?cid=${cid}&detail=YES`).then((response) => {
                setCustomer(response.data)
            })

            const purifierDetails = customerAxios.get(`/service/purifier?cid=${cid}&spare=YES`).then((response) => {
                setPurifier(response.data)
            })

            const serviceCardList = customerAxios.get(`/service/purifier/cards?cid=${cid}&spare=YES`).then((response) => {
                setCardList(response.data)
            })

            const cardImageList = customerAxios.get(`/service/image?cid=${cid}`).then((response) => {
                setCardImageList(response.data)
            })

            const eligibility = customerAxios.get(`/service/purifier/eligibility?cid=${cid}`).then((response) => {
                setEligibility(response.data)
            })


            Promise.all([customerDetails, purifierDetails, serviceCardList, cardImageList, eligibility])
                .then(() => setLoading('')).catch(() => {
                    toast.error('Some error, Try now!')
                    navigate(-1)
                    setLoading('')
                })
        }
        // eslint-disable-next-line
    }, [cid])



    return (
        <div className="customer-card-details">
            <div className="top-div">
                <h3>#{customer?.cid}<span>_{(customer?.full_name)?.toUpperCase()}</span></h3>
            </div>
            <div className="section-border-div">
                <div className="left-div">
                    {/* Personal Details */}
                    <div className="list-border-div">
                        <div className="list-title">
                            <FaDotCircle />
                            <h4>Personal details</h4>
                        </div>
                        {loading
                            ? <Spinner message='Loading...' height={'150px'} />
                            : <div className="title-content">
                                <div className="list-div">
                                    <div className="one-div">
                                        <p>Address, Place</p>
                                    </div>
                                    <div className="two-div">
                                        <p>: {customer?.address?.address}, {customer?.address?.place}</p>
                                    </div>
                                </div>
                                <div className="list-div">
                                    <div className="one-div">
                                        <p>Post, pin code</p>
                                    </div>
                                    <div className="two-div">
                                        <p>: P.O {customer?.address?.post} - {customer?.address?.pin_code}</p>
                                    </div>
                                </div>
                                <div className="list-div">
                                    <div className="one-div">
                                        <p>City</p>
                                    </div>
                                    <div className="two-div">
                                        <p>: {customer?.address?.city_name}</p>
                                    </div>
                                </div>
                                <div className="list-div">
                                    <div className="one-div">
                                        <p>Land mark</p>
                                    </div>
                                    <div className="two-div">
                                        <p>: {customer?.address?.land_mark}</p>
                                    </div>
                                </div>
                                <div className="list-div">
                                    <div className="one-div">
                                        <p>State</p>
                                    </div>
                                    <div className="two-div">
                                        <p>: {customer?.address?.state_name}</p>
                                    </div>
                                </div>
                                {customer?.contact1 && <div className="list-div">
                                    <div className="one-div">
                                        <p>Contact (1)</p>
                                    </div>
                                    <div className="two-div">
                                        <p>: {customer?.contact1}</p>
                                    </div>
                                </div>}
                                {customer?.contact2 && <div className="list-div">
                                    <div className="one-div">
                                        <p>Contact (2)</p>
                                    </div>
                                    <div className="two-div">
                                        <p>: {customer?.contact2}</p>
                                    </div>
                                </div>}
                                <div className="list-div">
                                    <div className="one-div">
                                        <p>Whatsapp</p>
                                    </div>
                                    <div className="two-div">
                                        <p>: {customer?.whatsapp1}</p>
                                    </div>
                                </div>
                                <div className="list-div credit-amt">
                                    <div className="one-div">
                                        <p>Credit amount</p>
                                    </div>
                                    <div className="two-div">
                                        <p>: ₹{customer?.credit_amount || 0}</p>
                                    </div>
                                </div>
                                <div className="list-div debit-amt">
                                    <div className="one-div">
                                        <p>Debit amount</p>
                                    </div>
                                    <div className="two-div">
                                        <p>: ₹{customer?.debit_amount || 0}</p>
                                    </div>
                                </div>
                            </div>}
                    </div>

                    {/* Service Details */}
                    <div className="list-border-div">
                        <div className="list-title">
                            <FaDotCircle />
                            <h4>Purifier details</h4>
                        </div>
                        {loading
                            ? <Spinner message='Loading...' height={'150px'} />
                            : <div className="title-content">
                                <div className="list-div">
                                    <div className="one-div">
                                        <p>Model</p>
                                    </div>
                                    <div className="two-div">
                                        <p>: {purifier?.product_name}</p>
                                    </div>
                                </div>
                                <div className="list-div">
                                    <div className="one-div">
                                        <p>Model category</p>
                                    </div>
                                    <div className="two-div">
                                        <p>: {purifier?.product_category}</p>
                                    </div>
                                </div>
                                <div className="list-div">
                                    <div className="one-div">
                                        <p>Product usage</p>
                                    </div>
                                    <div className="two-div">
                                        <p>: {purifier?.product_usage}</p>
                                    </div>
                                </div>
                                {purifier?.installed_at && <div className="list-div">
                                    <div className="one-div">
                                        <p>Installation date</p>
                                    </div>
                                    <div className="two-div">
                                        <p>{`: ${new Date(purifier?.installed_at).toDateString()}`}</p>
                                    </div>
                                </div>}
                                <div className="list-div">
                                    <div className="one-div">
                                        <p>Purifier status</p>
                                    </div>
                                    <div className="two-div">
                                        <p>: <span className={`text-badge ${purifier?.purifier_customer_status}-text`}>{purifier?.purifier_customer_status}</span></p>
                                    </div>
                                </div>
                                {purifier?.package_id && <div className="list-div">
                                    <div className="one-div">
                                        <p>Package Id</p>
                                    </div>
                                    <div className="two-div">
                                        <p>: {purifier?.package_id}</p>
                                    </div>
                                </div>}
                                <div className="list-div">
                                    <div className="one-div">
                                        <p>Package Start date</p>
                                    </div>
                                    <div className="two-div">
                                        <p>{`: ${purifier?.package_started_date ? new Date(purifier?.package_started_date).toDateString() : '-'}`}</p>
                                    </div>
                                </div>
                                <div className="list-div">
                                    <div className="one-div">
                                        <p>Package Expiry date</p>
                                    </div>
                                    <div className="two-div">
                                        <p>{`: ${purifier?.package_expiry_date ? new Date(purifier?.package_expiry_date).toDateString() : '-'}`}</p>
                                    </div>
                                </div>
                                <div className="list-div">
                                    <div className="one-div">
                                        <p>Carbon Start date</p>
                                    </div>
                                    <div className="two-div">
                                        <p>{`: ${purifier?.carbon_filter_start_date ? new Date(purifier?.carbon_filter_start_date).toDateString() : '-'}`}</p>
                                    </div>
                                </div>
                                <div className="list-div">
                                    <div className="one-div">
                                        <p>Carbon Expiry date</p>
                                    </div>
                                    <div className="two-div">
                                        <p>{`: ${purifier?.carbon_filter_expiry_date ? new Date(purifier?.carbon_filter_expiry_date).toDateString() : '-'}`}</p>
                                    </div>
                                </div>
                                <div className="list-div">
                                    <div className="one-div">
                                        <p>Next service date</p>
                                    </div>
                                    <div className="two-div">
                                        <p>{`: ${purifier?.next_periodical_service_date ? new Date(purifier?.next_periodical_service_date).toDateString() : '-'}`}</p>
                                    </div>
                                </div>
                                <div className="list-div">
                                    <div className="one-div">
                                        <p>Service Count</p>
                                    </div>
                                    <div className="two-div">
                                        <div className="icons">
                                            {purifier?.service_count?.map((count, index) => (
                                                <span key={index} className={count?.status ? 'add' : 'delete'}>
                                                    {count?.status
                                                        ? <IoMdCheckmarkCircle title={count?.srl_number} />
                                                        : <IoMdRemoveCircle title={count?.reason} />}</span>
                                            ))}
                                            {!purifier?.service_count?.[0] && <p>: No services</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="list-div">
                                    <div className="one-div">
                                        <p>Complaint count</p>
                                    </div>
                                    <div className="two-div">
                                        <div className="icons">{purifier?.complaint_count?.map((count, index) => (
                                            <span key={index} className={count?.status ? 'add' : 'delete'}>
                                                {count?.status
                                                    ? <IoMdCheckmarkCircle title={count?.srl_number} />
                                                    : <IoMdRemoveCircle title={count?.reason} />}</span>
                                        ))}
                                            {!purifier?.complaint_count?.[0] && <p>: No complaints</p>}
                                        </div>
                                    </div>
                                </div>
                                {purifier?.purifier_customer_status === 'SSP' && <div className="list-div">
                                    <div className="one-div">
                                        <p>SSP Card No</p>
                                    </div>
                                    <div className="two-div">
                                        <p>: {purifier?.ssp_card_number || '-'}</p>
                                    </div>
                                </div>}
                                {purifier?.purifier_customer_status === 'SSP' && <div className="list-div">
                                    <div className="one-div">
                                        <p>SSP Pending Tokens</p>
                                    </div>
                                    <div className="two-div">
                                        <p>: {purifier?.pending_ssp_token || 0}</p>
                                    </div>
                                </div>}
                            </div>}
                    </div>

                    {/* Description Details */}
                    <div className="list-border-div">
                        <div className="list-title">
                            <FaDotCircle />
                            <h4>Current descriptions</h4>
                        </div>
                        {loading
                            ? <Spinner message='Loading...' height={'150px'} />
                            : <div className="title-content">
                                {purifier?.purifier_work_description?.[0]
                                    ? <>
                                        {purifier?.purifier_work_description?.map((obj) => <div className="list-div">
                                            <div className="one-div">
                                                <p>{new Date(obj?.date).toDateString()}</p>
                                            </div>
                                            <div className="two-div">
                                                <p>: {obj?.description} ({obj?.by})</p>
                                            </div>
                                        </div>)}
                                    </>
                                    : <div className="list-div">
                                        <div className="one-div">
                                            <p>Not available</p>
                                        </div>
                                    </div>}
                            </div>}
                    </div>

                    {/* Eligibility Details */}
                    <div className="list-border-div">
                        <div className="list-title">
                            <FaDotCircle />
                            <h4>About Eligibility</h4>
                        </div>
                        {loading
                            ? <Spinner message='Loading...' height={'150px'} />
                            : <div className="title-content">
                                {/* Renewal */}
                                <div className="list-div">
                                    <div className="one-div">
                                        <p>Renewal</p>
                                    </div>
                                    <div className="two-div">
                                        <p>: {eligibility.renewal ? "Yes" : "No"}</p>
                                        <small>{!eligibility.renewal && "It's not renewal time"}</small>
                                    </div>
                                </div>
                                {/* AMC Renewal */}
                                {eligibility.renewal && <div className="list-div">
                                    <div className="one-div">
                                        <p>AMC Renewal</p>
                                    </div>
                                    <div className="two-div">
                                        <p>: {eligibility.amc ? "Yes" : "No"}</p>
                                        <small>{eligibility.why_not_amc}</small>
                                    </div>
                                </div>}
                                {/* SSP Renewal */}
                                {eligibility.renewal && <div className="list-div">
                                    <div className="one-div">
                                        <p>SSP Renewal</p>
                                    </div>
                                    <div className="two-div">
                                        <p>: Yes</p>
                                    </div>
                                </div>}
                                <div className="list-div">
                                    <div className="one-div">
                                        <p>Service</p>
                                    </div>
                                    <div className="two-div">
                                        <p>: {eligibility?.service ? "Yes" : "No"}</p>
                                        <small>{!eligibility.service && "It's not service time"}</small>
                                    </div>
                                </div>
                                <div className="list-div">
                                    <div className="one-div">
                                        <p>Take Credit</p>
                                    </div>
                                    <div className="two-div">
                                        <p>: {eligibility.credit ? "Yes" : "No"}</p>
                                        <small>{eligibility.why_not_credit}</small>
                                    </div>
                                </div>
                            </div>}
                    </div>

                    {/* Star Details */}
                    <div className="list-border-div">
                        <div className="list-title">
                            <FaDotCircle />
                            <h4>Star rate</h4>
                        </div>
                        {loading
                            ? <Spinner message='Loading...' height={'150px'} />
                            : <div className="title-content">
                                <div className='star-rate-div'>
                                    <Rating allowFraction size={35} initialValue={customer?.star_rate || 0} readonly={true} />
                                    <h3>{parseFloat(customer?.star_rate || 0).toFixed(1)}</h3>
                                </div>


                                <div className="list-div">
                                    <div className="one-div">
                                        <p>Premium</p>
                                    </div>
                                    <div className="two-div" style={{ display: 'flex', gap: "10px" }}>
                                        : <Rating allowFraction size={20} initialValue={parseFloat((customer?.star_details?.premium || 0) * 5).toFixed(1)} readonly={true} />
                                        <p>{parseFloat((customer?.star_details?.premium || 0) * 5).toFixed(1)}</p>
                                    </div>
                                </div>
                                <div className="list-div">
                                    <div className="one-div">
                                        <p>Behavior</p>
                                    </div>
                                    <div className="two-div" style={{ display: 'flex', gap: "10px" }}>
                                        : <Rating allowFraction size={20} initialValue={parseFloat((customer?.star_details?.behavior || 0) * 5).toFixed(1)} readonly={true} />
                                        <p>{parseFloat((customer?.star_details?.behavior || 0) * 5).toFixed(1)}</p>
                                    </div>
                                </div>
                                <div className="list-div">
                                    <div className="one-div">
                                        <p>Service</p>
                                    </div>
                                    <div className="two-div" style={{ display: 'flex', gap: "10px" }}>
                                        : <Rating allowFraction size={20} initialValue={parseFloat((customer?.star_details?.service || 0) * 5).toFixed(1)} readonly={true} />
                                        <p>{parseFloat((customer?.star_details?.service || 0) * 5).toFixed(1)}</p>
                                    </div>
                                </div>
                                <div className="list-div">
                                    <div className="one-div">
                                        <p>Continuity</p>
                                    </div>
                                    <div className="two-div" style={{ display: 'flex', gap: "10px" }}>
                                        : <Rating allowFraction size={20} initialValue={parseFloat((customer?.star_details?.continuity || 0) * 5).toFixed(1)} readonly={true} />
                                        <p>{parseFloat((customer?.star_details?.continuity || 0) * 5).toFixed(1)}</p>
                                    </div>
                                </div>
                                <div className="list-div">
                                    <div className="one-div">
                                        <p>Payment</p>
                                    </div>
                                    <div className="two-div" style={{ display: 'flex', gap: "10px" }}>
                                        : <Rating allowFraction size={20} initialValue={parseFloat((customer?.star_details?.payment || 0) * 5).toFixed(1)} readonly={true} />
                                        <p>{parseFloat((customer?.star_details?.payment || 0) * 5).toFixed(1)}</p>
                                    </div>
                                </div>
                            </div>}
                    </div>
                </div>
                <div className="right-div">
                    <div className="div-border">
                        <div className="list-title">
                            <FaDotCircle />
                            <h4>Service cards</h4>
                        </div>
                        <div className="color-info-div">
                            <div className="color-div">
                                <div className='color-box amount'></div>
                                <p>Amount</p>
                            </div>
                            <div className="color-div">
                                <div className='color-box primary'></div>
                                <p>Primary</p>
                            </div>
                            <div className="color-div">
                                <div className='color-box secondary'></div>
                                <p>Secondary</p>
                            </div>
                            <div className="color-div">
                                <div className='color-box special'></div>
                                <p>Special work</p>
                            </div>
                        </div>
                        <div className="card-list-div">

                            {!cardList?.[0] && !cardImageList?.[0] &&
                                <Spinner height={'300px'} message='No service cards' icon={<PiCardholderDuotone />} spin={false} />}
                            {purifier?.package_continuity_uncomforted && <div className="info-temp-div" style={{ marginTop: "17px" }}>
                                <InfoBox title={'Not interested for package renewal'}
                                    description={`The technician confirmed the customer not interested for renewal SSP / AMC package.`} />
                            </div>}
                            {cardList?.[0] &&
                                <>{cardList?.map((card, index) => {
                                    if (card?.installation) {
                                        return <InstallationCard key={index} data={card} />
                                    } else if (card?.re_installation) {
                                        return <InstallationCard key={index} data={card} re={true} />
                                    } else if (card?.service_card) {
                                        return <ServiceCard key={index} data={card} />
                                    }
                                    return null
                                })}</>}
                        </div>
                        <div className="card-image-div">
                            {cardImageList?.[0] && <>
                                {cardImageList?.map((card) => <img alt={card.image.key} src={card.image.url} />)}
                            </>}
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default CustomerCardDetails